// extracted by mini-css-extract-plugin
export default {"root":"ViewPageHeader_root__IpSaW","btn-group":"ViewPageHeader_btn-group__nV-7l"};